// extracted by mini-css-extract-plugin
export var animationAbsolute = "_23-q";
export var animationRelative = "_23-p";
export var backdropBlur = "_23-0";
export var detailLabelCell = "_23-12";
export var detailTable = "_23-11";
export var detailValueCell = "_23-13";
export var docIconBox = "_23-1d";
export var docIconBoxMd = "_23-1f";
export var docIconBoxSm = "_23-1e";
export var docTypeRow = "_23-16";
export var docTypeRowInner = "_23-17";
export var dropdownMatchDatePicker = "_23-3";
export var evidenceCardContent = "_23-1c";
export var fileUploadSpin = "_23-j";
export var gorgiasOpenButton = "_23-15 _23-d";
export var gorgiasTicketCard = "_23-14";
export var heroModalFooterButton = "_23-18";
export var hiddenContainer = "_23-o";
export var iconPrimary = "_23-1g";
export var iconQuaternary = "_23-1i";
export var iconTertiary = "_23-1h";
export var integrationCard = "_23-1";
export var integrationLogoBox = "_23-2";
export var mainColumnSticky = "_23-1b";
export var maxWidthContainer = "_23-19";
export var modalContentBody = "_23-a";
export var modalHeaderImage = "_23-5";
export var modalImageLabel = "_23-7";
export var modalImageOverlay = "_23-6";
export var modalImageSubtitle = "_23-9";
export var modalImageTitle = "_23-8";
export var modalImageWrapper = "_23-4";
export var modalStickyFooter = "_23-b";
export var removeButton = "_23-e";
export var sidebarColumn = "_23-1a";
export var spinner = "_23-i";
export var timelineLine = "_23-y";
export var timelineLineBlack = "_23-10 _23-y";
export var timelineLineGray = "_23-z _23-y";
export var timelineLineHeight = "_23-x";
export var tlDotActivate = "_23-u";
export var tlDotActivateAnim = "_23-t";
export var tlDotHide = "_23-s";
export var tlDotHideAnim = "_23-r";
export var tlLineActivate = "_23-w";
export var tlLineActivateAnim = "_23-v";
export var uploadHint = "_23-n";
export var uploadIconBox = "_23-k";
export var uploadLabel = "_23-m";
export var uploadText = "_23-l";
export var uploadZone = "_23-f";
export var uploadZoneCursorDefault = "_23-h";
export var uploadZoneCursorPointer = "_23-g";
export var uploadedFileRow = "_23-c";
export var viewButton = "_23-d";